import * as React from 'react';

import S from './styles';

interface Props {
  color?: string;
}

const Spinner = ({ color }: Props) => {
  return (
    <S.StyledSpinner>
      <S.SpinnerInternalBar color={color} />
      <S.SpinnerBar2 color={color} />
      <S.SpinnerBar3 color={color} />
      <S.SpinnerBar4 color={color} />
      <S.SpinnerBar5 color={color} />
    </S.StyledSpinner>
  );
};

export { Spinner as default };
